const COLORS = {
  PRIMARY: "primary",
  WHITE: "white",
};

const SIZES = {
  SMALL: "s",
  MEDIUM: "medium",
  LARGE: "large",
  EXTRA_LARGE: "extraLarge",
};

export { COLORS, SIZES };
